import { createFileRoute } from '@tanstack/react-router';
import { DeliveryPage } from '@/features/pda/delivery/delivery-page';

export const Route = createFileRoute('/_app/delivery')({ component: DeliveryPage });
